module.exports = __webpack_public_path__ + "static/media/xiaolianActive.fc0539c2.png";